import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import jsPDF from "jspdf";
import { addHeader, addFooter } from "common/PDFUtils/pdfUtils";
import { addSignature } from "common/PDFUtils/pdfUtils";
import { addTitle } from "common/PDFUtils/pdfUtils";
import { justifyText } from "common/PDFUtils/pdfUtils";
import logo from '../../../../../../assets/img/benjy-logo.png'


export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,

    defaultData,
    
    //------------- Forms
    Forms,
    helpers,
    
    globalStates

})=>{

    const navigate = useNavigate();


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickNewManagement = () => {
        
        // navigate si funcionó
        navigate('/gestiones-creditos-form')
    }

    const handleClickInfoManagement = (idgestion, openingmode) => {
        
        // navigate si funcionó
        navigate(`/gestiones-creditos-form/${openingmode}/${idgestion}`)
    }

    const handleClickDeleteManagement = (idgestion) => {

        const { fetchAllManagements } = FetchData
        const { executeFetchAllManagements } = fetchAllManagements

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/credits/mgmt-managements/management/${idgestion}`)
                .then(({data}) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllManagements()
                    }
                    
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un problema',
                        text: 'Comuniquese con mantenimiento'
                    })
                })
            }
        })
    }

    const generatePDF = async (idgestion, idcredito, depositos_sin_aprobar) => {

        if (depositos_sin_aprobar > 0) {
            return Swal.fire({
                icon: 'warning',
                title: 'No es posible descargar el finiquito',
                text: 'Existen depósitos pendientes de aprobación para este crédito.'
            })
        }

        // const {FormGlobal:{formState, setFormState}} = Forms
        // const {fetchInfoContract:{executeFetchInfoContract, loadingData}} = FetchData
        const {
            convertirCantidadALetras,
            getCurrentDate,
            getCurrentYear,
            convertirFechaALetras
        } = helpers

        const { setDataPdfDoc } = globalStates

        const fecha_actual = getCurrentDate()
        
        let data = []

        try {
            const response = await marvarApi.get(`/credits/common/get-application-ID/${idcredito}`)
            data = response.data.data
            // console.log('[useActions][generatePDF] data ::: ', data)
        } catch (e) {
            console.log(e)
        }


        const doc = new jsPDF();
        let y = 65
        let x = 20
        let texto


        
        //Agregamos los logos
        addHeader(doc)
        doc.setFontSize(12);
        doc.text(`Finiquito No. GES-CRED-${idgestion}`, 170, 35, null, null, 'center');
        
        //Titulo
        doc.setFontSize(15);
        addTitle(doc, y, 'FINIQUITO TOTAL')
        y+=20;
        
        // Cargar el archivo de texto
        try {
            const response = await fetch('/PDFText/FiniquitoVehiculo/finiquito.txt');
            if (!response.ok) {
                throw new Error('Error al cargar el archivo');
            }
            texto = await response.text();
        } catch (error) {
            console.error('Hubo un problema al cargar el archivo: ', error);
        }
        
        const anio_numero = getCurrentYear()
        // const fecha_letras = convertirFechaALetras(data.credito_dia_pago)
        // const monto_letra = convertirCantidadALetras(data.saldo_financiar)
        const fecha_actual_letras = convertirFechaALetras(fecha_actual)
        
        texto = texto
        .replace("{cliente}", data.cliente || '' )
        .replace("{dpi}", data.dpi || '')
        .replace("{identificador}", `CRED${data.idcredito}` || '')
        // .replace("{tipo}", data.tipo || '')
        // .replace("{marca}", data.marca || '')
        // .replace("{linea}", data.linea || '')
        // .replace("{modelo}", data.modelo || '')
        // .replace("{matricula}", data.matricula || '')
        // .replace("{chasis}", data.chasis || '')
        // .replace("{motor}", data.motorNo || '')
        // .replace("{cilindros}", data.motorCC || '')  
        .replace("{fecha_letras}", fecha_actual_letras)
        .replace("{anio_numero}", anio_numero)
        // .replace("{fecha}", data.credito_dia_pago || '')  
        // .replace("{monto_letra}", monto_letra || '')  
        // .replace("{monto}", data.saldo_financiar || '')  
        // .replace("{fecha_actual_letras}", fecha_actual_letras || '')  
        // .replace("{fecha_actual}", fecha_actual || '')  
        
        doc.setFont("times", "normal");
        doc.setFontSize(12);

        console.log('[generatePDF] texto :: ', texto)

        y = justifyText(doc, texto, 20, y, 170)

        // Firma (Dulce Pinto)
        addSignature(doc, y)

        // Pie de página
        addFooter(doc)
    
        // Guardar el PDF
        const docName = `FINIQUITO-CRED${data.idcredito}.pdf`
        doc.save(docName);
    };


    const fetchDataQuotation = async (idcotizacion) => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/herr-cotizador-credito/quotation/${idcotizacion}`)
            return response.data.data
        } catch (e) {
            console.log(e)
        }
    }

    const generateCotizacionPDF = async(idcotizacion) => {

        const quotation = await fetchDataQuotation(idcotizacion)

        const cliente = quotation[0]?.nombre_cliente || 'Cliente desconocido'; 
        const numeroCotizacion = quotation[0]?.numero_cotizacion || 'Sin número de cotización';
        const fecha = quotation[0]?.fecha || ' '; 
        const saldoFinanciar = quotation[0]?.saldo_financiar || 'Sin saldo financiar'; 
        const observaciones = quotation[0]?.descripcion || ''; 
        
        const doc = new jsPDF();
        
        let y = 15

        const imgWidth = 50; 
        const imgHeight = 20; 
        doc.addImage(logo, 'PNG', 150, 26, imgWidth, imgHeight); // (imagen, tipo, x, y, ancho, alto)
    
        // Membrete
        doc.setFont("helvetica", "bold");
        doc.setFontSize(25);
        doc.text('Cotización de Créditos', 105, y, null, null,"center"); // Texto del membrete
        y+=20;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(numeroCotizacion, 15, y);
        y+=5;
        doc.text(`Fecha: ${fecha}`, 15, y); 
        y+=5;
        doc.text(`Cliente: ${cliente}`, 15, y);
        y+=5;
        doc.text(`Saldo inicial: ${saldoFinanciar}`, 15, y);
        y+=10;
    
        // Crear la tabla
        const columns = ['No. Cuota', 'Amortizacion', 'Intereses', 'Seguro', 'GPS', 'Otros', 'Cuota Niv.', 'Cuota Pagar', 'Saldo'];
        const rows = quotation.map(cuota => [
            cuota.no_cuota,
            cuota.amortizacion,
            cuota.intereses,
            // cuota.gastos,
            cuota.seguro,
            cuota.gps,
            cuota.otros,
            cuota.cuota_niv,
            cuota.cuota_pagar,
            cuota.saldo,
          ]);
    
        // Agregar la tabla al PDF
        const tableResult = doc.autoTable({
          head: [columns],
          body: rows,
          startY: y, 
        });

        y = doc.lastAutoTable.finalY + 15;

        doc.setFont("times", "normal");
        doc.setFontSize(12);
        y = justifyText(doc, `Observaciones: ${observaciones}`, 15, y, 190); 
    
        y+=7;
        
        doc.setFontSize(12);
        doc.setFont("times", "italic");
        doc.text('* Esta cotización es válida por 8 días.', 10, y);
    
        // Guardar el PDF
        doc.save('cotizacion_creditos.pdf');
    };


  

    return Object.freeze({
        handleClickNewManagement,
        handleClickInfoManagement,
        handleClickDeleteManagement,
        generatePDF,
        generateCotizacionPDF
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}